import React from 'react'

import Visualizer from './components/Visualizer'
import './App.css'

function App() {
  return (
    <div className="App">
      <Visualizer />
    </div>
  )
}

export default App
